import { ZoomSlider } from 'ol/control';
import { default as RControlBase } from './RControlBase';
/**
 * ZoomSlider control
 *
 * Requires an `RMap` context
 */
export default class RZoomSlider extends RControlBase {
    constructor(props, context) {
        super(props, context);
        this.ol = new ZoomSlider(this.toOLProps(props));
    }
    toOLProps(props) {
        return Object.assign(Object.assign({}, super.toOLProps(props)), { duration: props.duration });
    }
}
//# sourceMappingURL=RZoomSlider.js.map